// extracted by mini-css-extract-plugin
export default {"contentWrapper":"MobileAccountSettings_contentWrapper__5RJS+"};